import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Spinner, Form } from 'react-bootstrap';
import config from '../../Common/Configurations/APIConfig';
import apiService from '../../Common/Configurations/APIService';
import './HolidayScreen.css';
import { LandingContext } from '../Profile/LandingContext'; // Import the context
import DefaultData from '../../CompanyData/DefaultData';


const destinationImages = [
    'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?q=80&w=1966', 'https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bWFsZGl2ZXN8ZW58MHx8MHx8fDA%3D', 'https://images.unsplash.com/photo-1534067783941-51c9c23ecefd?q=80&w=1974', 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?q=80&w=2070', 'https://images.unsplash.com/photo-1526772662000-3f88f10405ff?q=80&w=1974', 'https://images.unsplash.com/photo-1542051841857-5f90071e7989?q=80&w=2070', 'https://plus.unsplash.com/premium_photo-1697729438401-fcb4ff66d9a8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8a2VyYWxhfGVufDB8fDB8fHww', 'https://images.unsplash.com/photo-1736099513064-dc772ccc1d81?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjN8fFRhbWlsbmFuZHV8ZW58MHx8MHx8fDA%3D'
];
const travelTypeVisuals = {
    default: { icon: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16"><path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-3.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 3.6zM8 5.113L1.562 2.648 8 0l6.438 2.648L8 5.113z" /></svg>, color: '#0d6efd' },
    'group': { icon: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16"><path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" /></svg>, color: '#198754' },
    'corporate': { icon: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16"><path d="M7.024 1.566a.5.5 0 0 1 .952 0l1.205 2.436.03.061.053.012 2.686.612a.5.5 0 0 1 .278.853l-1.944 1.896-.046.045.011.054 .458 2.675a.5.5 0 0 1-.726.528L8.01 9.71l-.053-.028-.053.028-2.399 1.26a.5.5 0 0 1-.726-.528l.458-2.675.01-.054-.046-.045L2.73 5.53a.5.5 0 0 1 .278-.853l2.686-.612.053-.012.03-.061z" /><path d="M10.828.122A.5.5 0 0 1 11 .5V9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .672-.474l1.5 1.5 1.5-1.5z" /></svg>, color: '#0dcaf0' },
    'honeymoon': { icon: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314" /></svg>, color: '#dc3545' },
    'pilgrims': { icon: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16"><path d="M8.5 2.5a.5.5 0 0 0-1 0V3H6a1 1 0 0 0-1 1v1H4a1 1 0 0 0-1 1v1H2a1 1 0 0 0-1 1v1H.5a.5.5 0 0 0 0 1H1v1a1 1 0 0 0 1 1h1v1a1 1 0 0 0 1 1h1v.5a.5.5 0 0 0 1 0V13h1.5a1 1 0 0 0 1-1v-1H12a1 1 0 0 0 1-1V9h1a1 1 0 0 0 1-1V7h.5a.5.5 0 0 0 0-1H15V5a1 1 0 0 0-1-1h-1V3a1 1 0 0 0-1-1H8.5z" /></svg>, color: '#ffc107' }
};

const HeroSection = ({ travelTypes }) => {
    const landingData = useContext(LandingContext);
    const navigate = useNavigate();
    const [destination, setDestination] = useState('');
    const [travelType, setTravelType] = useState('');
    const [month, setMonth] = useState('');

    const [suggestions, setSuggestions] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [itemSelected, setItemSelected] = useState(false);
    const searchContainerRef = useRef(null);

    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    useEffect(() => {
        if (destination.trim() === '' || !DefaultData.DEFAULTCOMPANYID || itemSelected) {
            setSuggestions([]);
            return;
        }

        const delayDebounceFn = setTimeout(() => {
            const fetchSuggestions = async () => {
                setIsSearching(true);
                try {
                    const resourceUrl = `${config.GETDESTINATIONSEARCH}?keyword=${destination}&companyId=${DefaultData.DEFAULTCOMPANYID}`;
                    const response = await apiService.getAll(resourceUrl);
                    setSuggestions(response || []);
                } catch (error) {
                    console.error("Failed to fetch destination suggestions:", error);
                    setSuggestions([]);
                } finally {
                    setIsSearching(false);
                }
            };
            fetchSuggestions();
        }, 300); 

        return () => clearTimeout(delayDebounceFn);
    }, [destination, itemSelected]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
                setSuggestions([]);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        setSuggestions([]); 
        const query = new URLSearchParams({
            destination,
            traveltype: travelType,
            month,
        }).toString();
        navigate(`/holidays/search?${query}`);
    };

    const handleInputChange = (e) => {
        setItemSelected(false); 
        setDestination(e.target.value);
    };

    const handleSuggestionClick = (suggestion) => {
        setItemSelected(true); 
        setDestination(suggestion.destinationName);
        setSuggestions([]); 
    };

    const heroStyle = {
        backgroundImage: landingData ? `url(${landingData.holidayBackgroundSrc})` : 'none',
    };
    const searchButtonStyle = {
        backgroundColor: landingData?.themeColor1 || '#0d6efd',
        borderColor: landingData?.themeColor1 || '#0d6efd',
        paddingTop: '0.5rem',
        paddingBottom: '0.5rem'
    };

    return (
        <div className="holiday-hero-section" style={heroStyle}>
            <Container>
                <h1 className="display-4 fw-bold text-white">Find Your Perfect Trip</h1>
                <p className="lead mb-5">Search deals on hotels, homes, and much more...</p>
                <div className="hero-search-container">
                    <Form onSubmit={handleSearch} className="holiday-search-bar">
                        <Row className="g-3 align-items-end">
                            <Col md={4} ref={searchContainerRef} style={{ position: 'relative' }}>
                                <Form.Label>Destination</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g., Goa, Kerala, Maldives"
                                    value={destination}
                                    onChange={handleInputChange} 
                                    autoComplete="off"
                                />
                             
                                {(suggestions.length > 0 || isSearching) && (
                                    <div className="autocomplete-suggestions">
                                        {isSearching && <div className="suggestion-item">Searching...</div>}
                                        {!isSearching && suggestions.map(suggestion => (
                                            <div
                                                key={suggestion.destinationId}
                                                className="suggestion-item"
                                                onClick={() => handleSuggestionClick(suggestion)}
                                            >
                                                {suggestion.destinationName}
                                            </div>
                                        ))}
                                        {!isSearching && suggestions.length === 0 && destination.trim() !== '' && (
                                            <div className="suggestion-item">No results found</div>
                                        )}
                                    </div>
                                )}
                            </Col>
                            <Col md={3}>
                                <Form.Label>Travel Type</Form.Label>
                                <Form.Select
                                    value={travelType}
                                    onChange={(e) => setTravelType(e.target.value)}
                                >
                                    <option value="">All Types</option>
                                    {travelTypes.map(type => (
                                        <option key={type.travelTypeId} value={type.travelTypeName.toLowerCase()}>
                                            {type.travelTypeName}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col md={3}>
                                <Form.Label>Month</Form.Label>
                                <Form.Select
                                    value={month}
                                    onChange={(e) => setMonth(e.target.value)}
                                >
                                    <option value="">Any Month</option>
                                    {months.map(m => <option key={m} value={m.toLowerCase()}>{m}</option>)}
                                </Form.Select>
                            </Col>
                            <Col md={2} className="d-flex align-items-end">
                               <Button
                                    type="submit"
                                    className="w-100"
                                    style={searchButtonStyle}
                                >
                                    Search
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Container>
        </div>
    );
};

const DestinationsSection = ({ destinations }) => (
    <section className="mb-5 pb-4 fade-in-section">
        <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="section-title mb-0 text-start">Popular Destinations</h2>
        </div>
        <Row xs={1} md={2} lg={4} className="g-4">
            {destinations.slice(0, 8).map((dest, index) => (
                <Col key={dest.destinationId}>
                    <Link to={`/destination/${dest.destinationId}`} className="card-title-link">
                        <Card className="destination-card-modern">
                            <Card.Img
                                src={dest.imageSrc || destinationImages[index % destinationImages.length]}
                                alt={dest.destinationName}
                            />
                            <Card.ImgOverlay>
                                <Card.Title as="h4">{dest.destinationName}</Card.Title>
                            </Card.ImgOverlay>
                        </Card>
                    </Link>
                </Col>
            ))}
        </Row>
    </section>
);

const TravelTypesSection = ({ travelTypes }) => {
    if (!travelTypes || travelTypes.length === 0) return null;
    return (
        <section className="mb-5 pb-4 fade-in-section">
            <h2 className="section-title">Travel Your Way</h2>
            <Row xs={2} md={3} lg={5} className="g-4 justify-content-center">
                {travelTypes.map((type) => {
                    const visual = travelTypeVisuals[type.travelTypeName.toLowerCase()] || travelTypeVisuals.default;
                    return (
                        <Col key={type.travelTypeId}>
                            <Link to={`/packages/type/${type.travelTypeName.toLowerCase()}`} className="travel-type-card d-block" style={{ '--card-hover-color': visual.color }}>
                                <div className="travel-type-icon">{visual.icon}</div>
                                <Card.Title>{type.travelTypeName}</Card.Title>
                            </Link>
                        </Col>
                    );
                })}
            </Row>
        </section>
    );
};

const PackagesSection = ({ packages }) => (
    <section className="fade-in-section">
        <h2 className="section-title">Trending Packages</h2>
        <Row xs={1} md={2} lg={3} className="g-4">
            {packages.slice(0, 6).map(pkg => (
                <Col key={pkg.packageId}>
                    <Card className="package-card h-100">
                        <Card.Img variant="top" src={pkg.imageSrc || 'https://via.placeholder.com/400x200?text=Package'} alt={pkg.packageName} />
                        <Card.Body className="d-flex flex-column">
                            <Card.Title className="fw-bold mb-1">
                                <Link to={`/holiday-details/${pkg.packageId}`} className="card-title-link">
                                    {pkg.packageName}
                                </Link>
                            </Card.Title>
                            <div className="icon-text mb-2 small">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" /></svg>
                                <span>{pkg.destinationsCover}</span>
                            </div>
                            <div className="mt-auto pt-3">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div className="icon-text fw-medium">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" /></svg>
                                        <span>{pkg.duration}</span>
                                    </div>
                                    <span className="price-tag">{pkg.currency} {pkg.price}</span>
                                </div>
                                <div className="d-grid">
                                    <Button as={Link} to={`/holiday-details/${pkg.packageId}`} variant="primary">View Details</Button>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
    </section>
);

const HolidaysPage = () => {
    const [destinations, setDestinations] = useState([]);
    const [packages, setPackages] = useState([]);
    const [travelTypes, setTravelTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const companyId = DefaultData.DEFAULTCOMPANYID;

    useEffect(() => {
        const getHolidayData = async () => {
            setIsLoading(true);
            try {
                const [destinationsResponse, travelTypesResponse, packagesResponse] = await Promise.all([
                    apiService.getAll(config.GETALLDESTINATIONS),
                    apiService.getAll(config.GETALLTRAVELTYPES),
                    apiService.getAll(`${config.GETPACKAGEBYCOMAPANYID}/${companyId}?type=Holiday`),
                ]);
                setDestinations(destinationsResponse);
                setTravelTypes(travelTypesResponse);
                setPackages(packagesResponse.data);
            } catch (error) {
                console.error("Failed to fetch holiday data:", error);
            } finally {
                setIsLoading(false);
            }
        };
        getHolidayData();
    }, [companyId]);

    return (
        <>
            <div className="main-content">
                <div className="page-content" style={{ paddingTop: 0 }}>
                    <HeroSection travelTypes={travelTypes} />

                    <Container className="my-5 py-4">
                        {isLoading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '40vh' }}>
                                <Spinner animation="border" variant="primary" />
                                <span className="ms-2">Loading Content...</span>
                            </div>
                        ) : (
                            <>
                                <DestinationsSection destinations={destinations} />
                                <TravelTypesSection travelTypes={travelTypes} />
                                <PackagesSection packages={packages} />
                            </>
                        )}
                    </Container>
                </div>
            </div>

        </>
    );
};

export default HolidaysPage;